/**
 * Enables styling for the 2nd layer dropdown menu "Kliniken, Zentren, Kooperationen..." by adding a hover class to the menu-item
 * while the user hovers over the menu items children (children = 3rd layer)
 * @type {NodeListOf<Element>}
 */

const subHolders = document.querySelectorAll('#navbarSupportedContent .first-submenu-layer .ume-sub-sub-holder');

for(let holder of subHolders){
    let toggler = holder.querySelector('a[data-toggle="dropdown"]');
    let dropdownMenu = holder.querySelector('.dropdown-menu.dropdown-menu__side');

    if(toggler && dropdownMenu){
        dropdownMenu.addEventListener('mouseover', function (){
           toggler.classList.add('hover');
        });

        dropdownMenu.addEventListener('mouseleave', function (){
            toggler.classList.remove('hover');
        })
    }
}